import React, { Component } from 'react';
import { Card, CardTitle,CardBody, CardHeader, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import { TextInput } from '../editors';
import validator from 'validator';
import { metadataService } from '../../_services';

import PropTypes from "prop-types";

class BankingInfo extends Component {
    static displayName = BankingInfo.name;
    constructor(props) {
        super(props);
        this.state = {
            bankName: "",
            routingNumber: "",
            confirmRoutingNumber: "",
            accountNumber: "",
            confirmAccountNumber: "",
            fieldErrors: [],
            isSubComponentValid: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBankingInfoChange = this.handleBankingInfoChange.bind(this);

    }

    handleChange(e) {

        const { name, value } = e.target;
        const fieldName = metadataService.jsonFieldName(name);
        var newState = { [fieldName]: value }
        var finalState = { ...this.state, ...newState };

        finalState.canSubmit = this.isValid(finalState);
        finalState.isSubComponentValid = finalState.canSubmit;

        this.setState(finalState);

        this.handleBankingInfoChange(finalState);
//        if (this.isValid(finalState)) {
//            this.handleBankingInfoChange(finalState);
//        }
    }
    handleBankingInfoChange(state){
        if (this.props.handleBankingInfoChange) {
            this.props.handleBankingInfoChange(state);
        }
    }

    isValid(finalState) {

        let fieldErrors = [];
        let hasError = false;

        if (finalState.routingNumber !== finalState.confirmRoutingNumber) {
            fieldErrors.push({ fieldName: "ConfirmRoutingNumber", messageName: "ConfirmRoutingNumber" });
            hasError = true;
        }

        if (finalState.accountNumber !== finalState.confirmAccountNumber) {
            fieldErrors.push({ fieldName: "ConfirmAccountNumber", messageName: "ConfirmAccountNumber" });
            hasError = true;
        }

        finalState.fieldErrors = fieldErrors;

        if (!validator.isNumeric(finalState.routingNumber)) {
            hasError = true;
        }

        if (!validator.isLength(finalState.routingNumber, 9)) {
            hasError = true;
        }

        if (!validator.isNumeric(finalState.accountNumber)) {
            hasError = true;
        }

        if (hasError) {
            return false;
        } else {
            return true;
        }
    }



    render() {
        return (

            <div className="BankingInfo">
                <Row className="justify-content-center">
                    <Card>
                        <CardBody>
                            <CardTitle>{metadataService.getLabel("EnterBankingInfo")}</CardTitle>
                            <Row className={"no-gutters"}>
                                <TextInput
                                    name="AccountNumber"
                                    value={this.state.accountNumber}
                                    onChange={this.handleChange}
                                    isRequired={true}
                                    maskOnBlur={true}
                                    type={"number"} 
                                />
                            </Row>
                            <Row className={"no-gutters"}>
                                <TextInput
                                    name="ConfirmAccountNumber"
                                    value={this.state.confirmAccountNumber}
                                    onChange={this.handleChange}
                                    isRequired={true}
                                    maskOnBlur={true}
                                    fieldErrors={this.state.fieldErrors}
                                    type={"number"}
                                />
                            </Row>
                            <Row className={"no-gutters"}>
                                <TextInput
                                    name="RoutingNumber"
                                    value={this.state.routingNumber}
                                    onChange={this.handleChange}
                                    maxLength={9}
                                    isRequired={true}
                                    maskOnBlur={true}

                                    type={"number"}
                                />
                            </Row>
                            <Row className={"no-gutters"}>
                                <TextInput
                                    name="ConfirmRoutingNumber"
                                    value={this.state.confirmRoutingNumber}
                                    onChange={this.handleChange}
                                    maxLength={9}
                                    isRequired={true}
                                    maskOnBlur={true}
                                    fieldErrors={this.state.fieldErrors}

                                    type={"number"}
                                />
                            </Row>
                        </CardBody>
                    </Card>
                </Row>
            </div>
        );
    }
}



function mapStateToProps(state) {
    const { error, errorString } = state.newLoan;
    const { token } = state.authentication;
    return {
        error, errorString, token
    };
}

BankingInfo.proptypes = {
    handleBankingInfoChange: PropTypes.func
}

const connectedBankingInfo = connect(mapStateToProps)(BankingInfo);
export { connectedBankingInfo as BankingInfo };


// WEBPACK FOOTER //
// ./src/components/subcomponents/BankingInfo.js